import LabradorCoverBox, { StandaloneCoverBox, StandaloneCoverBoxProps } from '@/components/CoverBox';
import { StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

const HantStandaloneCoverBox: StandaloneComponent<StandaloneCoverBoxProps> = (props) => {
  return <StandaloneCoverBox {...mergeProps({ options: { className: 'hideInMobileApp' } }, props)} />;
};

export const standalone = HantStandaloneCoverBox;

export default LabradorCoverBox;
